import { inject, Injectable } from '@angular/core';
import { OccConfig } from '@spartacus/core';
import { DataSheet } from '../../models/classes/datasheet.model';

@Injectable()
export class ProductDataSheetService {
  occConfig = inject(OccConfig);

  getDownloadUrl(dataSheet: DataSheet) {
    return `${this.occConfig.backend?.occ?.baseUrl}${dataSheet?.downloadUrl}`;
  }

  getUrl(dataSheet: DataSheet) {
    return `${this.occConfig.backend?.occ?.baseUrl}${dataSheet?.url}`;
  }
}
